import { render, staticRenderFns } from "./pourquoi-communiquer-quand-on-est-une-entreprise.vue?vue&type=template&id=b7124d26&"
import script from "./pourquoi-communiquer-quand-on-est-une-entreprise.vue?vue&type=script&lang=js&"
export * from "./pourquoi-communiquer-quand-on-est-une-entreprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports